import React, { memo, useMemo } from "react";
import { BillingCycleType } from "../types";
import SubscriptionCard from "./SubscriptionCard";
import { MemberProduct, Member, PayChannel } from "@features/api/memberApi";
import { MemberPlanInfo } from "@hooks/useMemberUser";
import { CountDownTime } from "@/src/hooks/usePlusCountDown";

interface SubscriptionCardListProps {
  plans: MemberProduct[];
  billingCycle: BillingCycleType;
  isLoading: boolean;
  userPlanInfo: Member & MemberPlanInfo;
  isTrial: boolean;
  onChannelCheckout?: (planId: string, payChannel: PayChannel) => void;
  trialList?: MemberProduct[];
  hasActiveDiscount?: boolean;
  isDiscount?: boolean;
  time?: CountDownTime;
}

/**
 * 权益卡片列表组件 - 显示多个订阅计划卡片
 */
const CardList: React.FC<SubscriptionCardListProps> = ({
  plans,
  billingCycle,
  isLoading,
  userPlanInfo,
  isTrial,
  onChannelCheckout,
  trialList,
  hasActiveDiscount,
  isDiscount,
  time,
}) => {
  // 渲染订阅卡片
  const renderSubscriptionCards = useMemo(() => {
    return plans?.map((plan) => (
      <SubscriptionCard
        key={plan?.id}
        plan={plan}
        billingCycle={billingCycle}
        isLoading={isLoading}
        userPlanInfo={userPlanInfo}
        isTrial={isTrial}
        onChannelCheckout={onChannelCheckout}
        trialList={trialList}
        hasActiveDiscount={hasActiveDiscount}
        isDiscount={isDiscount}
        time={time}
      />
    ));
  }, [
    plans,
    billingCycle,
    isLoading,
    userPlanInfo,
    isTrial,
    onChannelCheckout,
    trialList,
    hasActiveDiscount,
    isDiscount,
    time,
  ]);

  return (
    <div className="flex flex-1 flex-wrap flex-row xl:gap-6 md:gap-4 max-md:gap-1 items-end justify-center mx-auto">
      {renderSubscriptionCards}
    </div>
  );
};

export default memo(CardList);
